import { useEffect } from 'react';
import { useIsAuthorized } from '@selfinspectionorg/auth/react';
import { PROFILE_PATH, SECURITY_PATH } from '@/app/paths';
import { redirectToPostAuthDestination } from '@/shared/auth/postAuthRedirect';

// Authorized visitors are normally bounced off any auth-app page to their role's default resource.
// These paths opt out:
// - `/auth/switch` runs an authorized→authorized change and owns the post-adoption redirect itself
//   (via `redirectToPostAuthDestination`); bouncing on arrival would abort the switch before it can
//   run.
// - `/auth/profile` is the app's genuinely authorized page — a signed-in user belongs here and must
//   stay, not be sent to their role resource.
// - `/auth/security` stays exempt for the lifetime of its redirect to `/auth/profile`, so the
//   post-auth bounce never races the redirect chain before it can hand off.
const REDIRECT_EXEMPT_PATHS = new Set(['/auth/switch', PROFILE_PATH, SECURITY_PATH]);

export const useAuthRedirect = () => {
  const isAuthorized = useIsAuthorized();

  useEffect(() => {
    if (!isAuthorized || REDIRECT_EXEMPT_PATHS.has(window.location.pathname)) {
      return;
    }

    redirectToPostAuthDestination();
  }, [isAuthorized]);
};
